<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">
      <div class="flex flex-row items-center">
        <div class="flex flex-row w-full">
          <div>
            <span style="font-weight:bold;">Surveys: </span>
            <span>{{list.length}}</span>
          </div>
        </div>

        <div class="flex flex-row">
          <button mat-icon-button *ngIf="editMode == 'list' && !labService.readonly" matTooltip="Add New Survey"
            (click)="add()" [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">add</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list' && !labService.readonly" matTooltip="Save" (click)="save()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">save</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Print" (click)="print(0)"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">printer</mat-icon>
          </button>

          <button mat-icon-button *ngIf="editMode == 'edit'" matTooltip="Delete Survey" (click)="delete(0)"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete</mat-icon>
          </button>
          <button mat-icon-button *ngIf="editMode !== 'list'" matTooltip="Cancel" (click)="cancel()"
            [matTooltipShowDelay]="750">
            <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">cancel</mat-icon>
          </button>
        </div>
      </div>
    </mat-card>
  </div>
  <!-- Survey Lists -->
  <div class="flex flex-row" *ngIf="editMode == 'list'">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
      'bg-gray-700': sharedService.userTheme === 'dark',
      'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col" *ngIf="list.length > 0">
          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                class="mat-elevation-z8 w-full">
                <ng-container matColumnDef="surveyId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>IDs</th>
                  <td mat-cell *matCellDef="let change">{{change.surveyId}}</td>
                </ng-container>
                <ng-container matColumnDef="surveyDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Date</th>
                  <td mat-cell *matCellDef="let change">{{change.surveyDate}}</td>
                </ng-container>
                <ng-container matColumnDef="surveyType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Survey Type</th>
                  <td mat-cell *matCellDef="let change">{{change.surveyType}}</td>
                </ng-container>
                <ng-container matColumnDef="surveyors">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>surveyors</th>
                  <td mat-cell *matCellDef="let change">{{change.surveyor1}} {{change.surveyor2}} {{change.surveyor3}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="conditionLevel">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Cond. Level</th>
                  <td mat-cell *matCellDef="let change">{{change.conditionLevel}}</td>
                </ng-container>
                <ng-container matColumnDef="followUpDue">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Follow Up Due</th>
                  <td mat-cell *matCellDef="let change">{{change.followUpDue}}</td>
                </ng-container>
                <ng-container matColumnDef="followUpDone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Follow Up Done</th>
                  <td mat-cell *matCellDef="let change">{{change.followUpDone}}</td>
                </ng-container>
                <ng-container matColumnDef="onSiteFollowUp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>On-Site Follow Up</th>
                  <td mat-cell *matCellDef="let change">{{change.onSiteFollowUp}}</td>
                </ng-container>
                <ng-container matColumnDef="deficiencies">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiencies</th>
                  <td mat-cell *matCellDef="let change">{{change.deficiency}}</td>
                </ng-container>
                <ng-container matColumnDef="hoursOnSite">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Hours on Site</th>
                  <td mat-cell *matCellDef="let change">{{change.hoursOnSite}}</td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="flex flex-row float-right">
                      <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Edit" (click)="edit(row)"
                        [matTooltipShowDelay]="750">
                        <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">edit</mat-icon>
                      </button>
                      <button mat-icon-button matTooltip="Print" (click)="print(row.surveyId)"
                        [matTooltipShowDelay]="750">
                        <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''">printer</mat-icon>
                      </button>
                      <button mat-icon-button *ngIf="!labService.readonly" matTooltip="Delete"
                        (click)="delete(row.surveyId)" [matTooltipShowDelay]="750">
                        <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">delete
                        </mat-icon>
                      </button>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()" #TablePaginator="matPaginator" showFirstLastButtons>
          </mat-paginator>
        </div>

      </mat-card-content>

    </mat-card>
  </div>

  <!-- Survey Edit/Add -->
  <form [formGroup]="surveyFormGroup">
    <div class="flex flex-col" *ngIf="editMode !== 'list'">
      <div class="flex flex-row gap-4">
        <div class="flex flex-row flex-wrap w-1/2 sm:flex-col gap-4">
          <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
            <mat-card-content>
              <div class="flex flex-col">
                <div class="flex flex-col mt-4">

                  <mat-form-field>
                    <mat-label>Survey Date</mat-label>
                    <input matInput [matDatepicker]="SurveyDate" formControlName="SurveyDate"
                      (dateChange)="updateDaysCalculations()">
                    <mat-datepicker-toggle matSuffix [for]="SurveyDate"></mat-datepicker-toggle>
                    <mat-datepicker #SurveyDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('SurveyDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Surveyor #1</mat-label>
                    <mat-select formControlName="Surveyor1">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of surveyorList" [value]="types.initials">{{types.initials}} -
                        {{types.fullname}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="surveyFormGroup.get('Surveyor1').invalid">
                      Certificate Type cannot be longer than 1 character
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Surveyor #2</mat-label>
                    <mat-select formControlName="Surveyor2">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of surveyorList" [value]="types.initials">{{types.initials}} -
                        {{types.fullname}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="surveyFormGroup.get('Surveyor1').invalid">
                      Certificate Type cannot be longer than 1 character
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Surveyor #3</mat-label>
                    <mat-select formControlName="Surveyor3">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of surveyorList" [value]="types.initials">{{types.initials}} -
                        {{types.fullname}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="surveyFormGroup.get('Surveyor1').invalid">
                      Certificate Type cannot be longer than 1 character
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Follow Up Due</mat-label>
                    <input matInput [matDatepicker]="FollowUpDue" formControlName="FollowUpDue">
                    <mat-datepicker-toggle matSuffix [for]="FollowUpDue"></mat-datepicker-toggle>
                    <mat-datepicker #FollowUpDue></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('FollowUpDue').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label># Condition Level</mat-label>
                    <input matInput formControlName="ConditionLevel">
                    <mat-error *ngIf="surveyFormGroup.get('ConditionLevel').invalid">
                      This field is 2 char max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Hours On Site</mat-label>
                    <input matInput formControlName="HoursOnSite">
                    <mat-error *ngIf="surveyFormGroup.get('HoursOnSite').invalid">
                      This field is 3 char max.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>SOD/Letter Sent</mat-label>
                    <input matInput [matDatepicker]="SodSentDate" formControlName="SodSentDate"
                      (dateChange)="updateDaysCalculations()">
                    <mat-datepicker-toggle matSuffix [for]="SodSentDate"></mat-datepicker-toggle>
                    <mat-datepicker #SodSentDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('SodSentDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Packet Completed</mat-label>
                    <input matInput [matDatepicker]="PacketCompletedDate" formControlName="PacketCompletedDate"
                      (dateChange)="updateDaysCalculations()">
                    <mat-datepicker-toggle matSuffix [for]="PacketCompletedDate"></mat-datepicker-toggle>
                    <mat-datepicker #PacketCompletedDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('PacketCompletedDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="flex flex-row flex-wrap w-1/2 sm:flex-col gap-4">
          <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
            <mat-card-content>
              <div class="flex flex-col">
                <div class="flex flex-col mt-4">

                  <mat-form-field>
                    <mat-label>Survey Type</mat-label>
                    <mat-select formControlName="SurveyType">
                      <mat-option value=""></mat-option>
                      <mat-option *ngFor="let types of surveyTypes" [value]="types.key">{{types.value}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="surveyFormGroup.get('SurveyType').invalid">
                      Required Field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Total Volume</mat-label>
                    <input matInput formControlName="TotalVolume" readonly>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Deficiencies</mat-label>
                    <input matInput formControlName="Deficiency" readonly>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>On-site Follow Up</mat-label>
                    <mat-select formControlName="OnSiteFollowUp">
                      <mat-option value="N">No</mat-option>
                      <mat-option value="Y">Yes</mat-option>
                    </mat-select>
                    <mat-error *ngIf="surveyFormGroup.get('OnSiteFollowUp').invalid">
                      Required Field.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Follow Up Done</mat-label>
                    <input matInput [matDatepicker]="FollowUpDone" formControlName="FollowUpDone">
                    <mat-datepicker-toggle matSuffix [for]="FollowUpDone"></mat-datepicker-toggle>
                    <mat-datepicker #FollowUpDone></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('FollowUpDone').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Survey Scheduled</mat-label>
                    <input matInput [matDatepicker]="ScheduleDate" formControlName="ScheduleDate">
                    <mat-datepicker-toggle matSuffix [for]="ScheduleDate"></mat-datepicker-toggle>
                    <mat-datepicker #ScheduleDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('ScheduleDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>POC Received</mat-label>
                    <input matInput [matDatepicker]="PocReceivedDate" formControlName="PocReceivedDate"
                      (dateChange)="updateDaysCalculations()">
                    <mat-datepicker-toggle matSuffix [for]="PocReceivedDate"></mat-datepicker-toggle>
                    <mat-datepicker #PocReceivedDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('PocReceivedDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Packet Reviewed/Uploaded</mat-label>
                    <input matInput [matDatepicker]="PacketReviewDate" formControlName="PacketReviewDate"
                      (dateChange)="updateDaysCalculations()">
                    <mat-datepicker-toggle matSuffix [for]="PacketReviewDate"></mat-datepicker-toggle>
                    <mat-datepicker #PacketReviewDate></mat-datepicker>
                    <mat-error *ngIf="surveyFormGroup.get('PacketReviewDate').invalid">
                      Invalid Date.
                    </mat-error>
                  </mat-form-field>

                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

      <div class="flex flex-row gap-4">
        <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
          <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
            <mat-card-content>
              <div class="flex flex-col gap-4 w-full">
                <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">

                  <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                    <h6>Principles of Documentation </h6>
                  </div>

                  <div class="flex flex-col w-full">
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                      Principles of Documentation correct?
                    </div>
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                      <mat-form-field>
                        <mat-label>Survey Outcome Oriented?</mat-label>
                        <mat-select formControlName="SurveyOutcomeOriented" matTooltip="Survey Outcome Oriented">
                          <mat-option value="Y">Yes</mat-option>
                          <mat-option value="N">No</mat-option>
                        </mat-select>
                        <mat-error *ngIf="surveyFormGroup.get('SurveyOutcomeOriented').invalid">
                          Required Field.
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4" style="padding-bottom:10px;">
                      <button type="button" mat-raised-button color="primary" (click)="addDeficiency()">Add
                        Deficiency</button>
                    </div>
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4" style="padding-bottom:10px;">
                      <table mat-table [dataSource]="deficiencySource" multiTemplateDataRows matSort
                        #TableSort2="matSort" class="mat-elevation-z8 flex-1 min-w-[95%]">

                        <ng-container matColumnDef="deficiencies">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Deficiency</th>
                          <td mat-cell *matCellDef="let def">
                            <mat-form-field class="flex-1 min-w-[90%] sm:min-w-full">
                              <input matInput placeholder="Deficiency" [(ngModel)]="def.deficiency"
                                [ngModelOptions]="{standalone:true}" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="totalSod">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>% Total SOD</th>
                          <td mat-cell *matCellDef="let def">
                            <mat-select [(value)]="def.sod" matTooltip="SOD"
                              (selectionChange)="updatePocSodCalculations()">
                              <mat-option value="100">100%</mat-option>
                              <mat-option value="87.5">87.5%</mat-option>
                              <mat-option value="75">75%</mat-option>
                              <mat-option value="62.5">62.5%</mat-option>
                              <mat-option value="50">50%</mat-option>
                              <mat-option value="37.5">37.5%</mat-option>
                              <mat-option value="25">25%</mat-option>
                              <mat-option value="12.5">12.5%</mat-option>
                              <mat-option value="0">0%</mat-option>
                            </mat-select>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="totalPoc">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>% Total POC</th>
                          <td mat-cell *matCellDef="let def">
                            <mat-select [(value)]="def.poc" matTooltip="POC"
                              (selectionChange)="updatePocSodCalculations()">
                              <mat-option value="100">100%</mat-option>
                              <mat-option value="75">75%</mat-option>
                              <mat-option value="50">50%</mat-option>
                              <mat-option value="25">25%</mat-option>
                              <mat-option value="0">0%</mat-option>
                            </mat-select>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="comments">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>comments</th>
                          <td mat-cell *matCellDef="let def">
                            <mat-form-field>
                              <textarea matInput cdkTextareaAutosize [(ngModel)]="def.comments" matTooltip="Comments"
                                [ngModelOptions]="{standalone:true}"></textarea>
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                          <td mat-cell *matCellDef="let row">
                            <button mat-icon-button matTooltip="Delete" (click)="deleteDeficiency(row)"
                              [matTooltipShowDelay]="750">
                              <mat-icon [ngClass]="sharedService.darkMode? 'dark-theme-icon' : ''" class="text-red-500">
                                delete
                              </mat-icon>
                            </button>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="deficiencyColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: deficiencyColumns;"></tr>
                      </table>
                    </div>
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                      <span style="font-weight:bold;">SOD Correct: </span>
                      <span>{{editSurvey.sodCorrect}} = (% of Total Deficiencies)</span>
                    </div>
                    <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                      <span style="font-weight:bold;">POC Correct: </span>
                      <span>{{editSurvey.pocCorrect}} = (% of Total Deficiencies)</span>
                    </div>
                  </div>
                </div>

                <div>
                  <table class="w-full">
                    <tr>
                      <td style="width: 30%;">
                        # Days from Survey Date to SOD Date
                      </td>
                      <td style="width: 20%;"> {{sodDateGoal}}</td>
                      <td style="width: 30%;">
                        # Days from SOD/Letter Sent to POC Received
                      </td>
                      <td style="width: 20%;"> {{daysSodToPoc}}</td>
                    </tr>
                    <tr>
                      <td>
                        # Days from POC Received to Packet Completed
                      </td>
                      <td> {{pocDateToCompleted}}</td>
                      <td>
                        # Days from Packet Completed to Reviewed
                      </td>
                      <td> {{daysToPacketReviewed}}</td>
                    </tr>
                    <tr>
                      <td>
                        Total Days of Survey Process
                      </td>
                      <td> {{totalDaysGoal}}</td>
                      <td>
                      </td>
                      <td></td>
                    </tr>
                  </table>
                </div>

                <span style="width: 100%;border-top: 1px solid black"></span>

                <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">
                  <div class="flex flex-row flex-wrap w-full sm:flex-col gap-4">>
                  </div>
                  <div class="flex flex-col w-full">
                    <mat-form-field>
                      <mat-label>Surveyor Comments</mat-label>
                      <textarea matInput cdkTextareaAutosize formControlName="SurveyorComments"></textarea>
                      <mat-error *ngIf="surveyFormGroup.get('SurveyorComments').invalid">
                        Cannot be longer than 4000 characters.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </div>
  </form>

</div>